import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Document as ContentfulDocument } from "@contentful/rich-text-types";
import { ClientSide } from "~/@types";
import { IInBriefFields } from "~/@types/generated/contentful";
import { getComponentFromContentfulRichTextEntry } from "~/contentful";
import {
  InsightComponentData,
  useComponentData,
} from "~/contexts/ComponentDataProvider";

export default function InBrief({
  moduleTitle,
  inBriefHeader,
  inBriefSummary,
}: ClientSide<IInBriefFields>) {
  const { insight } = useComponentData() as InsightComponentData;

  return (
    <>
      {inBriefSummary && (
        <section
          data-content-type="inBrief"
          data-module-title={moduleTitle}
          className="global-grid relative col-span-full my-8"
        >
          <div
            className="col-span-full px-6 py-10 text-white lg:col-start-4 lg:col-end-10 lg:ml-[-3.7rem] lg:mr-[-3.2rem] lg:py-9 lg:pl-[63px] lg:pr-[53px]"
            style={{ backgroundColor: insight?.fields.topic?.fields.color }}
          >
            <h2 className="ppe mb-8 text-4xl font-normal lg:mb-10 lg:text-5xl">
              {inBriefHeader || "In Brief"}
            </h2>
            <div className="body in-brief-body">
              {documentToReactComponents(
                inBriefSummary as ContentfulDocument,
                getComponentFromContentfulRichTextEntry,
              )}
            </div>
          </div>
        </section>
      )}
    </>
  );
}
